<template>
  <div id="match" >
    <!--<van-collapse v-model="activeNames" @change="getMatchGroupList" accordion>-->
    <!--<van-collapse-item class="asdfbd" v-for="item in matchList" :title="item.name" :name="item.id">-->
    <!--<van-cell v-if="groupList.length" v-for="group in groupList" :title="group.name" @click="routerGroup(group.id)" is-link />-->
    <!--</van-collapse-item>-->
    <!--</van-collapse>-->
    <van-search
      placeholder="请输入搜索关键词" shape="round"
      v-model="search"
      @change="onSearch"
      @search="onSearch"
      @cancel="onCancel">
      <div slot="action" @click="onSearch" >搜索</div>
    </van-search>
    <van-list
      v-if="membershipId"
      v-model="loading"
      :finished="finished"
      finished-text="没有更多了"
      @load="onLoad"
      :error.sync="error"
      error-text="请求失败，点击重新加载">
      <!--<van-cell v-for="item in list" :key="item.id" @click="onClickItem(item.id)">{{item.name}}</van-cell>-->
      <div class="match-list" v-for="item in list" :key="item.id" @click="onClickItem(item.id)">
        <img v-if="!item.logo" src="@/assets/images/hockey.png" >
        <img v-if="item.logo" :src="profileImg(item.logo)" @error="setErrorImg" >
        <div>
          {{item.name}}
        </div>
      </div>
    </van-list>
    <!-- 赛事组别 -->
    <van-popup v-model="isShowPopup" position="bottom" :overlay="true">
      <van-picker show-toolbar :columns="groupList" value-key="name" @change="onChange" @cancel="onCancel" @confirm="onConfirm" ></van-picker>
    </van-popup>
  </div>
</template>

<script>
import Vue from 'vue'
import { ImageFormat, defaultImg } from '@/utils'
import { getMyOrganization } from '@/api/info'
import { getMatchGroupList, getOrganizationInvolvedMatchList } from '@/api/match'
import { Search, List } from 'vant'

Vue.use(Search).use(List)

export default {
  name: 'MatchList',
  data() {
    return {
      isShowPopup: false,
      list: [],
      groupList: [],
      currentPage: 0,
      pageSize: 50,
      totalCount: 0,
      search: '',
      loading: false,
      finished: false,
      error: false,
      routerParams: {},
      membershipId: null
    }
  },
  created() {
    this.getMyOrganization()
    this.routerParams = this.$route.query
  },
  methods: {
    getMyOrganization() {
      getMyOrganization().then((resolve) => {
        let data = resolve.data
        this.membershipId = data.membership.id
      })
    },
    onLoad() {
      const params = {
        pageNum: this.currentPage + 1,
        pageSize: this.pageSize,
        allowTeamSignup: 1,
        name: this.search,
        organizationId: this.membershipId
      }
      getOrganizationInvolvedMatchList(params).then(response => {
        const data = response.data
        if (data) {
          // 处理数据
          if (data.matches.length > 0) {
            this.list = this.list.concat(data.matches)
            // 处理分页
            this.currentPage = data.pageNum
            this.totalCount = data.count
          } else {
            this.finished = true
          }
          this.loading = false
        }
      })
    },
    getMatchList() {
      const params = {
        pageNum: 1,
        pageSize: this.pageSize,
        allowTeamSignup: 1,
        name: this.search,
        organizationId: this.membershipId
      }
      getOrganizationInvolvedMatchList(params).then(response => {
        const data = response.data
        if (data) {
          this.list = data.matches
          if (data.matches.length <= this.pageSize) {
            this.finished = true
          }
        }
      })
    },
    onClickItem(matchId) {
      this.getMatchGroupList(matchId)
    },
    getMatchGroupList(matchId) {
      if (!matchId) {
        return
      }
      getMatchGroupList({ matchId: matchId }).then((resolve) => {
        let data = resolve.data
        this.groupList = data.list
        this.isShowPopup = true
      })
    },
    routerGroup(id) {
      this.$router.push({
        name: 'ScoreList',
        query: {
          groupId: id
        }
      })
    },
    routerTeamSignUp(id) {
      this.$router.push({
        name: 'TeamSignUp',
        query: {
          groupId: id
        }
      })
    },
    onSearch() {
      this.getMatchList()
    },
    onConfirm(value, index) {
      if (this.routerParams.type === 'grade') {
        this.routerGroup(value.id)
      } else if (this.routerParams.type === 'signUp') {
        this.routerTeamSignUp(value.id)
      }
      this.isShowPopup = false
    },
    onChange() {
    },
    onCancel() {
      this.isShowPopup = false
    },
    profileImg(img) {
      return ImageFormat.squareImageView(img, 100)
    },
    setErrorImg(e) {
      e.target.src = defaultImg
    }
  }
}
</script>

<style lang="scss" >
  #match {
    max-width: 768px; /*px*/
    position: absolute;
    width: 100%;
    height: 100%;
    background-color: white;
    .van-search {
      background-color: white;
      .van-search__content {
        background-color: white;
        border: 1px solid rgba(230,230,230,1);
        height: 45px;
        border-radius: 45px;
        line-height: 45px;
        .van-cell {
          .van-field__left-icon {
            display: flex;
            align-items: center;
            .van-icon {
              font-size: 28px;
              color: #979797;
            }
          }
          .van-cell__value {
            display: flex;
            align-items: center;
            color: #E2E2E2;
            font-size: 14px;
            .van-field__body {
              width: 100%;
            }
          }
        }
      }
    }
    .match-list {
      height: 50px;
      padding: 15px;
      display: flex;
      align-items: center;
      img {
        height: 50px;
        width: 50px;
        margin-right: 15px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/ucenter/team-manage.vue